/* ============================================================
   Luv Secret · PDP Template JS
   - Gallery thumbnail switching
   - Quantity stepper
   - Routine Builder v3 : live dynamic pricing breakdown
   - Sticky mobile bar reveal on scroll past hero
   - Cross-sell rail arrows
   ============================================================ */
(function () {
  'use strict';

  if (window.__luvPdpInit) return;
  window.__luvPdpInit = true;

  /* ----- Money formatting helper -----
     Uses the active locale and currency from Shopify if available; otherwise falls back to GBP. */
  var shopCurrency =
    (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
  var shopLocale =
    (window.Shopify && window.Shopify.locale) ||
    document.documentElement.lang ||
    'en-GB';

  function formatMoneyCents(cents) {
    try {
      var amount = cents / 100;
      var formatted = new Intl.NumberFormat(shopLocale, {
        style: 'currency',
        currency: shopCurrency,
        minimumFractionDigits: amount % 1 === 0 ? 0 : 2,
        maximumFractionDigits: 2
      }).format(amount);
      return formatted;
    } catch (e) {
      var sym = shopCurrency === 'GBP' ? '£' : shopCurrency === 'EUR' ? '€' : '$';
      return sym + (cents / 100).toFixed(0);
    }
  }

  /* ----- GALLERY (with prev/next arrows + keyboard + swipe : 2026-06-21) ----- */
  function initGallery() {
    document.querySelectorAll('[data-luv-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-luv-slide]');
      if (!slides.length) return;
      var galleryWrap = gallery.parentElement; // .luv-pdp-hero__gallery
      var thumbsWrap = galleryWrap ? galleryWrap.querySelector('.luv-pdp-hero__gallery-thumbs') : null;
      var thumbs = thumbsWrap ? thumbsWrap.querySelectorAll('[data-luv-thumb]') : [];
      var current = 0;
      var total = slides.length;

      function show(idx) {
        idx = ((idx % total) + total) % total; // safe wrap
        current = idx;
        slides.forEach(function (s) { s.classList.toggle('is-active', parseInt(s.dataset.luvSlide, 10) === idx); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', parseInt(t.dataset.luvThumb, 10) === idx); });
        // Scroll active thumb into view on mobile
        var activeThumb = thumbsWrap ? thumbsWrap.querySelector('[data-luv-thumb="' + idx + '"]') : null;
        if (activeThumb && activeThumb.scrollIntoView) {
          try { activeThumb.scrollIntoView({behavior: 'smooth', block: 'nearest', inline: 'nearest'}); } catch (e) {}
        }
      }
      function next() { show(current + 1); }
      function prev() { show(current - 1); }

      // Thumbnail clicks
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { show(parseInt(t.dataset.luvThumb, 10)); });
      });

      // Slide click = next (preserves prior behaviour; harmless on desktop because arrows are easier)
      slides.forEach(function (s) {
        s.addEventListener('click', function () { next(); });
      });

      // Prev/next arrows (rendered in Liquid)
      var prevBtn = gallery.querySelector('[data-luv-gallery-prev]');
      var nextBtn = gallery.querySelector('[data-luv-gallery-next]');
      if (prevBtn) prevBtn.addEventListener('click', function (e) { e.stopPropagation(); prev(); });
      if (nextBtn) nextBtn.addEventListener('click', function (e) { e.stopPropagation(); next(); });

      // Hide arrows if only one image
      if (total < 2) {
        if (prevBtn) prevBtn.setAttribute('hidden', '');
        if (nextBtn) nextBtn.setAttribute('hidden', '');
      }

      // Keyboard arrow keys when gallery (or its children) has focus
      gallery.setAttribute('tabindex', '0');
      gallery.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); next(); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); prev(); }
      });

      // Touch swipe on the gallery viewport
      var touchStartX = 0, touchStartY = 0, touchActive = false;
      gallery.addEventListener('touchstart', function (e) {
        if (!e.touches.length) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchActive = true;
      }, {passive: true});
      gallery.addEventListener('touchend', function (e) {
        if (!touchActive || !e.changedTouches.length) { touchActive = false; return; }
        var dx = e.changedTouches[0].clientX - touchStartX;
        var dy = e.changedTouches[0].clientY - touchStartY;
        touchActive = false;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) next(); else prev();
        }
      }, {passive: true});
    });
  }

  /* ----- QUANTITY STEPPER ----- */
  function initQty() {
    document.querySelectorAll('.luv-pdp-product-form').forEach(function (form) {
      var input = form.querySelector('[data-luv-qty-input]');
      var minus = form.querySelector('[data-luv-qty-minus]');
      var plus = form.querySelector('[data-luv-qty-plus]');
      if (!input) return;
      if (minus) minus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        if (v > 1) input.value = v - 1;
      });
      if (plus) plus.addEventListener('click', function () {
        var v = parseInt(input.value, 10) || 1;
        input.value = v + 1;
      });
    });
  }

  /* ============================================================
     ROUTINE BUILDER v3
     ============================================================
     Live discount rules (from Shopify Admin :
       gid://shopify/DiscountAutomaticNode/2272343720270  Bxgy 'heroes' 30%
       gid://shopify/DiscountAutomaticNode/2272876560718  10% off cart £180+
       gid://shopify/DiscountAutomaticNode/2272343687502  Free shipping £75+ )

     Hero discount maths :
       collect selected-hero prices, sort ASC.
       pair index 0 + 1, 2 + 3, 4 + 5, ...
       for each FULL pair, 30% off the cheaper hero (= index 0 of the pair).
       partial pair (single trailing hero) gets nothing.

     Cart reward maths :
       if (subtotal − heroDiscount) >= £180  →  10% × (subtotal − heroDiscount).
       This matches a DiscountAutomaticBasic applied after item-level discounts.

     Free candle £120 is shown only as a progress chip. No automatic-discount node
     currently exists in Shopify for that perk, so it is NOT subtracted from the
     estimated total. This preserves truthfulness in the displayed checkout estimate.
     ============================================================ */
  function initBuilder() {
    var builder = document.querySelector('[data-luv-builder]');
    if (!builder) return;

    var thresholds = {
      shipping: parseInt(builder.dataset.thresholdShipping, 10) || 7500,
      candle: parseInt(builder.dataset.thresholdCandle, 10) || 12000,
      discount: parseInt(builder.dataset.thresholdDiscount, 10) || 18000
    };
    var heroPercent = (parseInt(builder.dataset.heroPercent, 10) || 30) / 100;
    var cartRewardPercent = (parseInt(builder.dataset.cartRewardPercent, 10) || 10) / 100;

    var cards = builder.querySelectorAll('[data-luv-card]');
    var subtotalEl   = builder.querySelector('[data-luv-subtotal]');
    var heroRowEl    = builder.querySelector('[data-luv-hero-row]');
    var heroAmtEl    = builder.querySelector('[data-luv-hero-amount]');
    var heroDetailEl = builder.querySelector('[data-luv-hero-detail]');
    var cartRowEl    = builder.querySelector('[data-luv-cart-row]');
    var cartAmtEl    = builder.querySelector('[data-luv-cart-amount]');
    var totalEl      = builder.querySelector('[data-luv-builder-total]');
    var totalDetailEl= builder.querySelector('[data-luv-total-detail]');
    var atcEl        = builder.querySelector('[data-luv-builder-atc]');
    var fillEl       = builder.querySelector('[data-luv-progress-fill]');
    var msgEl        = builder.querySelector('[data-luv-progress-message]');
    var markers      = builder.querySelectorAll('.luv-pdp-builder__summary-markers li');
    var boxModeEl    = builder.querySelector('[data-luv-boxmode]');

    /* ----- BOX-MODE config (Liquid-pre-computed value ladder) -----
       When the user ticks EVERY member of this ritual the builder swaps
       to box-mode :
         - the cart will receive the Whole Ritual Box variant (single line),
           which is already priced with the built-in 10% ritual saving
         - the displayed total mirrors the same value ladder shown on the
           Liquid "Or take the full ritual" upsell : box.price − 30% hero
           − (10% if subtotal ≥ £180). */
    var boxVariantId    = parseInt(builder.dataset.boxVariantId, 10) || 0;
    var boxPriceCents   = parseInt(builder.dataset.boxPriceCents, 10) || 0;
    var boxCompareCents = parseInt(builder.dataset.boxCompareCents, 10) || 0;
    var boxFinalCents   = parseInt(builder.dataset.boxFinalCents, 10) || 0;
    var boxHeroCents    = parseInt(builder.dataset.boxHeroCents, 10) || 0;
    var boxSaveCents    = parseInt(builder.dataset.boxSaveCents, 10) || 0;
    var boxMemberSet = (builder.dataset.boxMemberHandles || '')
      .split(',')
      .map(function (h) { return h.trim(); })
      .filter(function (h) { return h.length > 0; });

    function allMembersSelected(sel) {
      if (!boxVariantId || boxMemberSet.length === 0) return false;
      var selectedHandles = sel.map(function (c) { return c.dataset.handle; });
      // Every member must be in the selected set.
      for (var i = 0; i < boxMemberSet.length; i++) {
        if (selectedHandles.indexOf(boxMemberSet[i]) === -1) return false;
      }
      return true;
    }

    function selectedNonCurrent(sel) {
      return sel.filter(function (c) { return c.dataset.isCurrent !== 'true'; });
    }

    var currentCard = builder.querySelector('[data-luv-card][data-is-current="true"]');
    var currentNameEl = currentCard ? currentCard.querySelector('.luv-pdp-builder__card-name') : null;
    var currentName = currentNameEl ? currentNameEl.textContent.trim() : 'this step';
    currentName = currentName.replace(/^The\s+/i, '');

    function selected() {
      return Array.prototype.filter.call(cards, function (c) { return c.classList.contains('is-selected'); });
    }

    function subtotalCents(sel) {
      return sel.reduce(function (sum, c) { return sum + (parseInt(c.dataset.priceCents, 10) || 0); }, 0);
    }

    /**
     * Hero pairing discount per the live Shopify Bxgy rule.
     * For each FULL pair of selected heroes (sorted ascending), discount 30% off the cheaper one.
     * @param {Array<HTMLElement>} sel
     * @returns {{discount: number, pairCount: number, heroCount: number}}
     */
    function heroDiscountCents(sel) {
      var heroPrices = sel
        .filter(function (c) { return c.dataset.isHero === 'true'; })
        .map(function (c) { return parseInt(c.dataset.priceCents, 10) || 0; })
        .sort(function (a, b) { return a - b; });
      var heroCount = heroPrices.length;
      var pairCount = Math.floor(heroCount / 2);
      var discount = 0;
      for (var i = 0; i < pairCount; i++) {
        // The cheaper of each pair is heroPrices[2*i]
        discount += Math.round(heroPrices[2 * i] * heroPercent);
      }
      return { discount: discount, pairCount: pairCount, heroCount: heroCount };
    }

    function cartRewardCents(subtotal, heroDiscount) {
      var afterHero = subtotal - heroDiscount;
      if (afterHero >= thresholds.discount) {
        return Math.round(afterHero * cartRewardPercent);
      }
      return 0;
    }

    /* Track whether we're currently in box-mode so the ATC handler can
       decide whether to add the single box variant or the multi-add list. */
    var inBoxMode = false;

    function update() {
      var sel = selected();
      var memberSel = allMembersSelected(sel);
      inBoxMode = memberSel;

      var heroes, extras, extrasCount;
      var subtotal, heroDisc, cartReward, estimatedTotal;
      var heroInfo;

      if (memberSel) {
        // BOX MODE : value ladder is pre-computed in Liquid from the box
        // product itself. Mirror it exactly so the displayed total matches
        // the "Or take the full ritual" upsell + Go-Deeper finale.
        subtotal = boxCompareCents > boxPriceCents ? boxCompareCents : boxPriceCents;
        heroDisc = boxHeroCents;
        // Box price already bakes in the built-in 10% ritual saving. The
        // additional checkout 10% only kicks in if (box.price − hero) ≥ £180.
        var afterHero = boxPriceCents - boxHeroCents;
        cartReward = afterHero >= thresholds.discount ? (afterHero - boxFinalCents) : 0;
        estimatedTotal = boxFinalCents;
        heroInfo = { discount: heroDisc, pairCount: 2, heroCount: 4 };
      } else {
        subtotal = subtotalCents(sel);
        heroInfo = heroDiscountCents(sel);
        heroDisc = heroInfo.discount;
        cartReward = cartRewardCents(subtotal, heroDisc);
        estimatedTotal = subtotal - heroDisc - cartReward;
      }

      heroes = heroInfo.heroCount;
      extras = selectedNonCurrent(sel);
      extrasCount = extras.length;

      // --- Breakdown ---
      if (subtotalEl) {
        // In box mode the subtotal label shows the standalone "Worth" of the ritual
        // (compare_at_price) so the customer can see why the box represents value.
        subtotalEl.textContent = formatMoneyCents(subtotal);
      }

      if (heroRowEl) {
        if (heroDisc > 0) {
          heroRowEl.hidden = false;
          if (heroAmtEl) heroAmtEl.textContent = '−' + formatMoneyCents(heroDisc);
          if (heroDetailEl) {
            if (memberSel) {
              heroDetailEl.textContent = '30% off 2 hero pairings, applied automatically';
            } else if (heroInfo.pairCount === 1) {
              heroDetailEl.textContent = '30% off your second Hero, paired automatically at checkout';
            } else {
              heroDetailEl.textContent = '30% off ' + heroInfo.pairCount + ' Hero pairings, applied automatically';
            }
          }
        } else {
          heroRowEl.hidden = true;
        }
      }

      if (cartRowEl) {
        if (cartReward > 0) {
          cartRowEl.hidden = false;
          if (cartAmtEl) cartAmtEl.textContent = '−' + formatMoneyCents(cartReward);
        } else {
          cartRowEl.hidden = true;
        }
      }

      if (totalEl) totalEl.textContent = formatMoneyCents(estimatedTotal);
      if (totalDetailEl) {
        if (memberSel) {
          totalDetailEl.textContent = 'Whole Ritual Box price · built-in 10% ritual saving + free candle.';
        } else if (extrasCount === 0) {
          totalDetailEl.textContent = 'Includes The ' + currentName + '.';
        } else if (extrasCount === 1) {
          totalDetailEl.textContent = '2 steps in your ritual, including The ' + currentName + '.';
        } else {
          totalDetailEl.textContent = (extrasCount + 1) + ' steps in your ritual, including The ' + currentName + '.';
        }
      }

      // --- Box-mode indicator badge ---
      if (boxModeEl) {
        boxModeEl.hidden = !memberSel;
      }

      // --- ATC button ---
      if (atcEl) {
        atcEl.disabled = false;
        var atcMoney = formatMoneyCents(estimatedTotal);
        if (memberSel) {
          atcEl.textContent = 'Add Whole Ritual · ' + atcMoney;
        } else if (extrasCount === 0) {
          atcEl.textContent = 'Add to Ritual · ' + atcMoney;
        } else if (extrasCount === 1) {
          atcEl.textContent = 'Add 2 steps · ' + atcMoney;
        } else {
          atcEl.textContent = 'Add ' + (extrasCount + 1) + ' steps · ' + atcMoney;
        }
      }

      // --- Progress fill : capped at 100% of discount threshold ---
      if (fillEl) {
        var pct = Math.min(100, (subtotal / thresholds.discount) * 100);
        fillEl.style.width = pct + '%';
      }

      // --- Markers hit state ---
      // Shipping/candle markers: based on subtotal.
      // Discount marker: based on AFTER-hero subtotal (the value Shopify uses for the 10% rule).
      markers.forEach(function (m) {
        var key = m.dataset.marker;
        var t = thresholds[key];
        var hit;
        if (key === 'discount') {
          hit = cartReward > 0;
        } else {
          hit = subtotal >= t;
        }
        m.classList.toggle('is-hit', hit);
      });

      // --- Progress message (single most-relevant nudge) ---
      // CRITICAL: only claim 10% reward is "unlocked" if cartReward > 0 (i.e. AFTER-hero subtotal also ≥ £180).
      // Subtotal alone is not enough to guarantee qualification because Shopify applies the BxGy hero
      // discount before evaluating the cart-level 10% rule.
      if (msgEl) {
        var afterHero = subtotal - heroDisc;
        if (extrasCount === 0) {
          msgEl.textContent = 'Your ritual starts with The ' + currentName + '. Add steps to unlock rewards.';
        } else if (cartReward > 0) {
          msgEl.textContent = '10% off your ritual, free shipping and your complimentary candle all unlocked. Beautifully done.';
        } else if (subtotal >= thresholds.discount && afterHero < thresholds.discount) {
          // Subtotal crossed £180 but the hero pairing brought it back below — show truthful nudge.
          var topUp = thresholds.discount - afterHero;
          msgEl.textContent = formatMoneyCents(topUp) + ' more (after your hero pairing) for 10% off your whole ritual.';
        } else if (subtotal >= thresholds.candle) {
          var toDiscount = thresholds.discount - subtotal;
          msgEl.textContent = formatMoneyCents(toDiscount) + ' more for 10% off your whole ritual.';
        } else if (subtotal >= thresholds.shipping) {
          var toCandle = thresholds.candle - subtotal;
          msgEl.textContent = formatMoneyCents(toCandle) + ' more to choose a complimentary signature candle.';
        } else {
          var toShipping = thresholds.shipping - subtotal;
          msgEl.textContent = formatMoneyCents(toShipping) + ' more for free shipping.';
        }
      }
    }

    cards.forEach(function (card) {
      var btn = card.querySelector('[data-luv-toggle]');
      if (!btn) return;
      // Current product is always selected and not toggleable
      if (card.dataset.isCurrent === 'true') {
        btn.setAttribute('aria-pressed', 'true');
        card.classList.add('is-selected');
        btn.disabled = true;
        return;
      }
      btn.addEventListener('click', function () {
        var pressed = btn.getAttribute('aria-pressed') === 'true';
        var next = !pressed;
        btn.setAttribute('aria-pressed', next ? 'true' : 'false');
        card.classList.toggle('is-selected', next);
        update();
      });
    });

    // Add ritual to bag : multi-add via /cart/add.js OR single box swap.
    // When inBoxMode is true (all ritual members ticked), we add the Whole
    // Ritual Box variant as one item instead of the individual members,
    // which means the customer pays the box.price × value-ladder total
    // rather than the multi-line subtotal.
    if (atcEl) {
      atcEl.addEventListener('click', function () {
        var sel = selected();
        if (sel.length === 0) return;
        atcEl.disabled = true;
        atcEl.textContent = 'Adding ...';

        var body;
        if (inBoxMode && boxVariantId) {
          body = { items: [{ id: boxVariantId, quantity: 1 }] };
        } else {
          var items = sel.map(function (c) {
            return { id: parseInt(c.dataset.variantId, 10), quantity: 1 };
          });
          body = { items: items };
        }

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(body)
        })
          .then(function (r) { return r.json(); })
          .then(function () { return refreshDrawerAndOpen(); })
          .then(function () {
            atcEl.disabled = false;
            try { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true })); } catch (e) {}
          })
          .catch(function () {
            atcEl.disabled = false;
            atcEl.textContent = 'Try again';
          });
      });
    }

    update();
  }

  /* ----- CROSS-SELL RAIL : desktop arrow controls + arrow enable/disable state ----- */
  function initCrossRail() {
    document.querySelectorAll('.luv-pdp-cross').forEach(function (section) {
      var rail = section.querySelector('[data-luv-cross-rail]');
      var prev = section.querySelector('[data-luv-cross-prev]');
      var next = section.querySelector('[data-luv-cross-next]');
      if (!rail) return;

      function step() {
        var first = rail.firstElementChild;
        if (!first) return 320;
        var gap = parseFloat(getComputedStyle(rail).columnGap || getComputedStyle(rail).gap || '14') || 14;
        return first.getBoundingClientRect().width + gap;
      }

      function updateArrows() {
        if (!prev || !next) return;
        var max = rail.scrollWidth - rail.clientWidth - 1;
        prev.toggleAttribute('disabled', rail.scrollLeft <= 0);
        next.toggleAttribute('disabled', rail.scrollLeft >= max);
      }

      if (prev) prev.addEventListener('click', function () {
        rail.scrollBy({ left: -step(), behavior: 'smooth' });
      });
      if (next) next.addEventListener('click', function () {
        rail.scrollBy({ left: step(), behavior: 'smooth' });
      });
      rail.addEventListener('scroll', function () { updateArrows(); }, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();
    });
  }

  /* ----- STICKY MOBILE BAR : show after hero scrolls past ----- */
  function initStickyBar() {
    var sticky = document.querySelector('[data-luv-sticky]');
    var hero = document.querySelector('.luv-pdp-hero');
    if (!sticky || !hero) return;

    function check() {
      var rect = hero.getBoundingClientRect();
      var shouldShow = rect.bottom < 80;
      sticky.classList.toggle('is-visible', shouldShow);
      sticky.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
    }

    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });
    check();
  }

  /* LUV v3 Cart Drawer Optimisation (2026-06-01) — ATC state machine
     ADD → ADDING → ADDED ✓, opens drawer immediately, no persistent spinner,
     double-click guard via dataset.luvState, locale-aware labels (EN/DE/FR/ES). */
  function getLuvLocale() {
    var l = (window.Shopify && window.Shopify.locale) ||
            document.documentElement.lang || 'en';
    l = String(l).toLowerCase().split('-')[0];
    if (['en','de','fr','es'].indexOf(l) === -1) l = 'en';
    return l;
  }
  var LUV_ATC_LABELS = {
    en: { add: 'Add to Ritual', adding: 'Adding', added: 'Added \u2713' },
    de: { add: 'In den Warenkorb', adding: 'Wird hinzugef\u00fcgt', added: 'Hinzugef\u00fcgt \u2713' },
    fr: { add: 'Ajouter au panier', adding: 'En cours', added: 'Ajout\u00e9 \u2713' },
    es: { add: 'A\u00f1adir a la cesta', adding: 'A\u00f1adiendo', added: 'A\u00f1adido \u2713' }
  };
  function setLuvAtcState(btn, state) {
    if (!btn) return;
    btn.dataset.luvState = state;
    var labelEl = btn.querySelector('.luv-pdp-hero__atc-label') || btn;
    var loc = getLuvLocale();
    var labels = LUV_ATC_LABELS[loc] || LUV_ATC_LABELS.en;
    // Preserve original label as data-label-add on first run
    if (!btn.hasAttribute('data-label-add')) {
      btn.setAttribute('data-label-add', (labelEl.textContent || labels.add).trim());
    }
    var addLbl = btn.getAttribute('data-label-add') || labels.add;
    if (state === 'adding') {
      labelEl.textContent = labels.adding;
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
    } else if (state === 'added') {
      labelEl.textContent = labels.added;
      btn.disabled = true;
      btn.removeAttribute('aria-busy');
    } else {
      labelEl.textContent = addLbl;
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  }
  function refreshDrawerAndOpen() {
    // Use Shopify\u2019s per-section endpoint (proven pattern from luv-cart-editorial.js)
    // /?section_id=cart-drawer returns the section\u2019s rendered HTML wrapped in <div class="shopify-section">
    var p1 = fetch('/?section_id=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('#CartDrawer');
          var live = document.querySelector('#CartDrawer');
          if (src && live) live.innerHTML = src.innerHTML;
        } catch (e) { /* swallow */ }
      })
      .catch(function () { /* swallow */ });
    var p2 = fetch('/?section_id=cart-icon-bubble', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        try {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('.shopify-section');
          var live = document.getElementById('cart-icon-bubble');
          if (src && live) live.innerHTML = src.innerHTML;
        } catch (e) { /* swallow */ }
      })
      .catch(function () { /* swallow */ });
    return Promise.all([p1, p2]).then(function () {
      var drawer = document.querySelector('cart-drawer');
      if (drawer) {
        drawer.classList.remove('is-empty');
        if (typeof drawer.open === 'function') drawer.open();
      }
      // Notify any other listeners (rewards bar, candle picker)
      try {
        fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            document.dispatchEvent(new CustomEvent('cart:update', {
              bubbles: true,
              detail: { resource: 'cart', sourceId: 'luv-pdp-atc', data: cart }
            }));
            window.__luvCart = cart;
          })
          .catch(function () {});
      } catch (e) {}
    });
  }
  function initMainAtc() {
    document.querySelectorAll('.luv-pdp-product-form').forEach(function (form) {
      if (form.dataset.luvWired === '1') return;
      form.dataset.luvWired = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('[name="add"]');
        if (!btn) { form.submit(); return; }
        if (btn.dataset.luvState === 'adding' || btn.dataset.luvState === 'added') return; // dbl-click guard
        setLuvAtcState(btn, 'adding');
        // Use FormData of the original product form (carries id, quantity, properties etc.)
        var formData = new FormData(form);
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        })
          .then(function (r) {
            // Shopify returns 200 on success, 422 on out-of-stock or variant issue
            if (!r.ok) {
              return r.text().then(function (t) {
                var err;
                try { err = JSON.parse(t); } catch (_) { err = { description: t.slice(0, 200) }; }
                throw err;
              });
            }
            return r.json();
          })
          .then(function () {
            // Item is in cart \u2014 confirm visually then refresh drawer
            setLuvAtcState(btn, 'added');
            // Refresh cart drawer + icon bubble via section_id endpoints (proven pattern from luv-cart-editorial)
            return refreshDrawerAndOpen();
          })
          .then(function () {
            // Restore button to idle after the confirmation moment (~1200ms total)
            setTimeout(function () { setLuvAtcState(btn, 'idle'); }, 700);
          })
          .catch(function (err) {
            // Restore button on error so user can retry
            setLuvAtcState(btn, 'idle');
            var msg = (err && (err.description || err.message)) || 'Could not add to cart. Please try again.';
            try { console.warn('[luv-atc] add failed:', msg); } catch(_) {}
          });
      });
    });
  }

  // Cross-sell card ATC: each card has its own button that adds the displayed
  // variant id to cart, then opens the drawer. The image+text wrap is still a
  // link to the PDP. v4 split structure.
  function initCrossSellAtc() {
    document.querySelectorAll('[data-luv-cross-add]').forEach(function (btn) {
      if (btn.dataset.luvWired === '1') return;
      btn.dataset.luvWired = '1';
      // Capture the original button text so we can restore after add/error.
      if (!btn.hasAttribute('data-label-add')) {
        btn.setAttribute('data-label-add', (btn.textContent || 'Add to Ritual').trim());
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled && btn.dataset.luvState !== 'added') return;
        if (btn.dataset.luvState === 'adding' || btn.dataset.luvState === 'added') return;
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        var loc = getLuvLocale();
        var labels = LUV_ATC_LABELS[loc] || LUV_ATC_LABELS.en;
        var origLabel = btn.getAttribute('data-label-add') || labels.add;
        btn.dataset.luvState = 'adding';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = labels.adding;
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) {
            if (!r.ok) {
              return r.text().then(function (t) {
                var err;
                try { err = JSON.parse(t); } catch (_) { err = { description: t.slice(0, 200) }; }
                throw err;
              });
            }
            return r.json();
          })
          .then(function () {
            btn.dataset.luvState = 'added';
            btn.textContent = labels.added;
            btn.removeAttribute('aria-busy');
            return refreshDrawerAndOpen();
          })
          .then(function () {
            setTimeout(function () {
              btn.dataset.luvState = 'idle';
              btn.disabled = false;
              btn.textContent = origLabel;
            }, 900);
          })
          .catch(function (err) {
            btn.dataset.luvState = 'idle';
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = origLabel;
            var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
            try { console.warn('[luv-cross-atc] add failed:', msg); } catch (_) {}
          });
      });
    });
  }

  // Builder box CTA: intercept the box form submit, add to cart via fetch,
  // open side drawer, stay on page. v1 (round 3).
  function initBoxCta() {
    document.querySelectorAll('[data-luv-box-cta]').forEach(function (btn) {
      if (btn.dataset.luvWired === '1') return;
      btn.dataset.luvWired = '1';
      if (!btn.hasAttribute('data-label-add')) {
        btn.setAttribute('data-label-add', (btn.textContent || 'Take the full ritual').trim());
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled && btn.dataset.luvState !== 'added') return;
        if (btn.dataset.luvState === 'adding' || btn.dataset.luvState === 'added') return;
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        var loc = getLuvLocale();
        var labels = LUV_ATC_LABELS[loc] || LUV_ATC_LABELS.en;
        var origLabel = btn.getAttribute('data-label-add') || labels.add;
        btn.dataset.luvState = 'adding';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = labels.adding;
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) {
            if (!r.ok) {
              return r.text().then(function (t) {
                var err;
                try { err = JSON.parse(t); } catch (_) { err = { description: t.slice(0, 200) }; }
                throw err;
              });
            }
            return r.json();
          })
          .then(function () {
            btn.dataset.luvState = 'added';
            btn.textContent = labels.added;
            btn.removeAttribute('aria-busy');
            return refreshDrawerAndOpen();
          })
          .then(function () {
            setTimeout(function () {
              btn.dataset.luvState = 'idle';
              btn.disabled = false;
              btn.textContent = origLabel;
            }, 900);
          })
          .catch(function (err) {
            btn.dataset.luvState = 'idle';
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = origLabel;
            var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
            try { console.warn('[luv-box-atc] add failed:', msg); } catch (_) {}
          });
      });
      // Also intercept form submit (in case the user hits Enter).
      var form = btn.closest('[data-luv-box-form]');
      if (form && form.dataset.luvWired !== '1') {
        form.dataset.luvWired = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          btn.click();
        });
      }
    });
  }

  // Inline ATC (variant-aware single-button form, lives multiple times per
  // box PDP): intercept submit, add to cart via fetch, open side drawer.
  function initInlineAtc() {
    document.querySelectorAll('[data-luv-inline-cta]').forEach(function (btn) {
      if (btn.dataset.luvWired === '1') return;
      btn.dataset.luvWired = '1';
      if (!btn.hasAttribute('data-label-add')) {
        btn.setAttribute('data-label-add', (btn.textContent || 'Add to Ritual').trim());
      }
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (btn.disabled && btn.dataset.luvState !== 'added') return;
        if (btn.dataset.luvState === 'adding' || btn.dataset.luvState === 'added') return;
        var variantId = btn.dataset.variantId;
        if (!variantId) return;
        var loc = getLuvLocale();
        var labels = LUV_ATC_LABELS[loc] || LUV_ATC_LABELS.en;
        var origLabel = btn.getAttribute('data-label-add') || labels.add;
        btn.dataset.luvState = 'adding';
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.textContent = labels.adding;
        var fd = new FormData();
        fd.append('id', variantId);
        fd.append('quantity', '1');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: fd
        })
          .then(function (r) {
            if (!r.ok) {
              return r.text().then(function (t) {
                var err;
                try { err = JSON.parse(t); } catch (_) { err = { description: t.slice(0, 200) }; }
                throw err;
              });
            }
            return r.json();
          })
          .then(function () {
            btn.dataset.luvState = 'added';
            btn.textContent = labels.added;
            btn.removeAttribute('aria-busy');
            return refreshDrawerAndOpen();
          })
          .then(function () {
            setTimeout(function () {
              btn.dataset.luvState = 'idle';
              btn.disabled = false;
              btn.textContent = origLabel;
            }, 900);
          })
          .catch(function (err) {
            btn.dataset.luvState = 'idle';
            btn.disabled = false;
            btn.removeAttribute('aria-busy');
            btn.textContent = origLabel;
            var msg = (err && (err.description || err.message)) || 'Could not add to cart.';
            try { console.warn('[luv-inline-atc] add failed:', msg); } catch (_) {}
          });
      });
      var form = btn.closest('[data-luv-inline-form]');
      if (form && form.dataset.luvWired !== '1') {
        form.dataset.luvWired = '1';
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          btn.click();
        });
      }
    });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () {
    initGallery();
    initQty();
    initBuilder();
    initStickyBar();
    initMainAtc();
    initCrossRail();
    initCrossSellAtc();
    initBoxCta();
    initInlineAtc();
  });

  document.addEventListener('shopify:section:load', function () {
    initGallery();
    initQty();
    initBuilder();
    initStickyBar();
    initCrossRail();
    initCrossSellAtc();
    initBoxCta();
    initInlineAtc();
  });
})();

/* cache-bust 1780000000-pdp-cta-unify-v1-r3 */

